/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Type} from '@angular/core';

import {Tooltip} from './tooltip';
import {TooltipContent} from './tooltip-content';
import {TooltipTrigger} from './tooltip-trigger';


export {Tooltip} from './tooltip';
export {TooltipTrigger} from './tooltip-trigger';
export {TooltipContent} from './tooltip-content';
export const /** @type {?} */ TOOLTIP_DIRECTIVES: Type<any>[] = [Tooltip, TooltipTrigger, TooltipContent];
